module.exports = "a {\n    cursor: pointer;\n}\n\n.user-avatar .fa-user-circle {\n    color:#99a3a9;\n}\n\n.user-avatar:hover .fa-user-circle {\n    color:#3DA1DA;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-header/app-header.component.css
// module id = ./src/app/components/app-header/app-header.component.css
// module chunks = main